<template>
  <el-dialog
    v-model="localDialogVisible"
    :modal="false"
    :show-close="false"
    width="50%"
    class="text-center"
  >
    <template #header>OCR</template>
    <el-upload
      ref="upload"
      :action="store.server + '/api/ocr'"
      list-type="picture-card"
      :file-list="fileList"
      :multiple="false"
      :limit="1"
      :data="options"
      :on-change="takePicture"
    >
      <el-icon><Plus /></el-icon>
    </el-upload>
    <br />
    <el-row>
      <el-button @click="cancel"> Cancel </el-button>
    </el-row>
  </el-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Plus } from '@element-plus/icons-vue'
import { useMainStore } from '@/stores/main'

const store = useMainStore()

const props = defineProps({
  dialogVisible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['close', 'update:dialogVisible'])

/**
 * Local dialog visibility computed for v-model binding
 * Syncs with parent prop and emits close on dialog close
 */
const localDialogVisible = computed({
  get: () => props.dialogVisible,
  set: (val) => {
    if (!val) {
      emit('close')
      emit('update:dialogVisible', val)
    }
  },
})

// Refs
const upload = ref(null)
const fileList = ref([])

// Computed properties
const options = computed(() => ({
  senderId: store.uid,
  recipientId: location.hostname,
}))

// Methods
function takePicture(files) {
  upload.value.clearFiles()
  emit('close')
}

function cancel() {
  emit('close')
}
</script>
